import { RetrieveResourceProjectsQuery } from "@planzone/dto";

function match(
  first: RetrieveResourceProjectsQuery,
  second: RetrieveResourceProjectsQuery,
) {
  return first.limit == second.limit;
}

export { match };
